import { h, Host } from "@stencil/core";
import { ICON_NAMESPACE } from "../../icons/namespace";
/** @internal This is soon to be replaced */
export class EsStatus {
  constructor() {
    this.status = undefined;
  }
  render() {
    return (h(Host, { class: this.status }, h("es-icon", { icon: this.icon, size: 16 }), h("span", null, this.text)));
  }
  get icon() {
    switch (this.status) {
      case 'critical':
        return [ICON_NAMESPACE, 'critical'];
      case 'degraded':
        return [ICON_NAMESPACE, 'degraded'];
      case 'okay':
      default:
        return [ICON_NAMESPACE, 'okay'];
    }
  }
  get text() {
    switch (this.status) {
      case 'critical':
        return 'Critical';
      case 'degraded':
        return 'Degraded';
      case 'okay':
        return 'OK';
      default:
        return 'Unknown';
    }
  }
  static get is() { return "es-status"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["es-status.css"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["es-status.css"]
    };
  }
  static get properties() {
    return {
      "status": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "Status",
          "resolved": "\"critical\" | \"degraded\" | \"okay\"",
          "references": {
            "Status": {
              "location": "local",
              "path": "/home/runner/work/Design-System/Design-System/packages/components/src/components/es-status/es-status.tsx",
              "id": "src/components/es-status/es-status.tsx::Status"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "status",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=es-status.js.map
